// import qs from "qs";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */


const VibaruaHelper = {
    install (Vue) {
        Vue.prototype.colors = () => {
            return ['#41B883', '#E46651', '#00D8FF', '#DD1B16', '#9c27b0', '#d500f9', '#9575cd', '#b388ff', '#3f51b5', '#536dfe',
                '#2196f3', '#8bc34a', '#fec60a', '#ff9800', '#ff5722', '#607d8b'];
        };
    },
};

export default VibaruaHelper;
